import React from 'react'
import {
  Box,
  Typography
} from "@mui/material";

function NoDataFound({title="No Data to Display" , 
                      discription=" Please use the search filters above to fetch and display data.", 
                      message="Use the search fields or advanced filters to get started."}) {
  return (
        <Box sx={{ textAlign: 'center', p: 3 }}>
            <Typography variant="h6" sx={{ color: '#666', mb: 2 }}>
             📊 {title}
            </Typography>
            <Typography variant="body1" sx={{ color: '#888', mb: 2 }}>
                {discription}
            </Typography>
            <Typography variant="body2" sx={{ color: '#aaa' }}>
                {message}
            </Typography>
        </Box>
  )
}

export default NoDataFound